var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Drawer",
    {
      attrs: { drawer: _vm.drawer, customTitle: "", size: 882 },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "top", attrs: { slot: "title" }, slot: "title" },
        [
          _c("p", { staticClass: "title" }, [
            _c("span", [_vm._v("对外系统提单推送-GGT")]),
            _c("span", { staticClass: "billNo" }, [
              _vm._v("提单号：" + _vm._s(_vm.billNo)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "file" },
            [
              _vm.fileList[0]?.fileName
                ? [
                    _c("span", { staticClass: "file-label" }, [
                      _vm._v("提单文件："),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "file-item",
                        attrs: { title: _vm.fileList[0]?.fileName },
                      },
                      [
                        _c("img", {
                          staticClass: "file-icon",
                          attrs: {
                            src: require("@/assets/images/bill/pdf.png"),
                            width: "12",
                          },
                        }),
                        _c("span", { staticClass: "file-name" }, [
                          _vm._v(_vm._s(_vm.fileList[0]?.fileName)),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "review",
                            on: {
                              click: function ($event) {
                                return _vm.check(_vm.fileList[0])
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "file-icon",
                              attrs: {
                                src: require("@/assets/images/bill/review.png"),
                                width: "12",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm.fileList[1]?.fileName
                ? [
                    _c(
                      "span",
                      {
                        staticClass: "file-label",
                        staticStyle: { "margin-left": "32px" },
                      },
                      [_vm._v("提单发票：")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "file-item",
                        attrs: { title: _vm.fileList[1]?.fileName },
                      },
                      [
                        _c("img", {
                          staticClass: "file-icon",
                          attrs: {
                            src: require("@/assets/images/bill/pdf.png"),
                            width: "12",
                          },
                        }),
                        _c("span", { staticClass: "file-name" }, [
                          _vm._v(_vm._s(_vm.fileList[1]?.fileName)),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _c("div", { staticClass: "title-opt" }, [
                _c(
                  "span",
                  {
                    staticClass: "opt-btn",
                    staticStyle: { color: "#5753E8 !important" },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible1 = true
                        _vm.type = 0
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-circle-plus-outline" }),
                    _vm._v(" 添加GGT抬头信息 "),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "opt-btn",
                    staticStyle: { color: "#5753E8 !important" },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible1 = true
                        _vm.type = 1
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-circle-plus-outline" }),
                    _vm._v(" 添加GGT Importer "),
                  ]
                ),
              ]),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "view" },
        [
          _c(
            "div",
            { staticClass: "data" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form",
                  attrs: { model: _vm.form, rules: _vm.rules },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "shipperSCINId",
                                label: "Shipper",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择Shipper",
                                  },
                                  model: {
                                    value: _vm.form.shipperSCINId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "shipperSCINId", $$v)
                                    },
                                    expression: "form.shipperSCINId",
                                  },
                                },
                                _vm._l(_vm.shipperOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "importerSCINId",
                                label: "Importer",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择Importer",
                                  },
                                  model: {
                                    value: _vm.form.importerSCINId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "importerSCINId", $$v)
                                    },
                                    expression: "form.importerSCINId",
                                  },
                                },
                                _vm._l(_vm.importerOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "consigneeSCINId",
                                label: "Consignee",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择Consignee",
                                  },
                                  model: {
                                    value: _vm.form.consigneeSCINId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "consigneeSCINId", $$v)
                                    },
                                    expression: "form.consigneeSCINId",
                                  },
                                },
                                _vm._l(_vm.consigneeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "notifyPartySCINId",
                                label: "Notify Party",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择客户",
                                  },
                                  model: {
                                    value: _vm.form.notifyPartySCINId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "notifyPartySCINId",
                                        $$v
                                      )
                                    },
                                    expression: "form.notifyPartySCINId",
                                  },
                                },
                                _vm._l(_vm.notifyPartyOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "manufactureSCINId",
                                label: "manufacturer",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择制造商",
                                  },
                                  model: {
                                    value: _vm.form.manufactureSCINId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "manufactureSCINId",
                                        $$v
                                      )
                                    },
                                    expression: "form.manufactureSCINId",
                                  },
                                },
                                _vm._l(_vm.manufactureOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "remark", label: "备注" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入备注" },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "doSupplierTemplateId",
                                label: "接收DO代理模板",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择接收DO代理模板",
                                  },
                                  on: { change: _vm.doChange },
                                  model: {
                                    value: _vm.form.doSupplierTemplateId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "doSupplierTemplateId",
                                        $$v
                                      )
                                    },
                                    expression: "form.doSupplierTemplateId",
                                  },
                                },
                                _vm._l(_vm.doOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "tpl-opt",
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogVisible = true
                                    },
                                  },
                                },
                                [_vm._v("模板管理")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("p", { staticClass: "po" }, [
                          _vm._v(
                            " 接收DO公司名称：" +
                              _vm._s(_vm.doObj.supplierName) +
                              " "
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "24px" } },
                            [
                              _vm._v(
                                " 接收DO公司邮箱：" +
                                  _vm._s(_vm.doObj.emails) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "footers" }, [
            _c(
              "div",
              { staticClass: "cancel flex_c_c", on: { click: _vm.close } },
              [_vm._v("取 消")]
            ),
            _c(
              "div",
              {
                staticClass: "ok flex_c_c",
                on: {
                  click: function ($event) {
                    return _vm.ok("form")
                  },
                },
              },
              [_vm._v("确 定")]
            ),
          ]),
          _c("DoTplDialog", {
            attrs: { dialogVisible: _vm.dialogVisible },
            on: {
              cancel: function ($event) {
                _vm.dialogVisible = false
              },
            },
          }),
          _c("SicnAddDialog", {
            attrs: {
              dialogVisible: _vm.dialogVisible1,
              mblId: _vm.mblId,
              type: _vm.type,
            },
            on: {
              cancel: function ($event) {
                _vm.dialogVisible1 = false
              },
              ok: _vm.ok1,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }